import { z } from 'zod';

/** Cursor pagination is used everywhere instead of offset/limit so list
 *  results stay stable as new rows are inserted between page loads. */
export const cursorPaginationQuery = z.object({
  cursor: z.string().min(1).max(200).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});

export type CursorPaginationQuery = z.infer<typeof cursorPaginationQuery>;

export interface CursorPage<T> {
  items: T[];
  nextCursor: string | null;
}
